import { render, staticRenderFns } from "./LoadGoods.vue?vue&type=template&id=6838f862"
import script from "./LoadGoods.vue?vue&type=script&lang=js"
export * from "./LoadGoods.vue?vue&type=script&lang=js"
import style0 from "./LoadGoods.vue?vue&type=style&index=0&id=6838f862&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports